(function(angular){
	'use strict';

	angular
		.module('plaidModule', [
			'BaseConfig'
		])
		.value('plaidConfig', plaidConfig);

})(window.angular);